import { useAppSelector } from 'store/hooks';
import { getHasSourceOfFundingInfo } from '../utils';
export const useHasSourceOfFundsInfo = () => {
    const { annualIncomeMin, annualIncomeMax, liquidNetWorthMin, liquidNetWorthMax, fundingSource, employmentStatus, } = useAppSelector((state) => state.user.userAdditionalInfo);
    return getHasSourceOfFundingInfo({
        annualIncomeMin,
        annualIncomeMax,
        liquidNetWorthMin,
        liquidNetWorthMax,
        fundingSource,
        employmentStatus,
    });
};
